module.exports = __webpack_public_path__ + "img/Group 4099.085043a9.png";